export default "__VITE_ASSET__7rzRnoix__"